// import { r4Client, r4Error } from '@/services'

const CampaignConversionStatsApi = {
  async fetchStats () {
  }
}

export default CampaignConversionStatsApi
